import { clsx } from 'clsx';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import styles from '../BasicParameters.module.scss';
import type { BasicParametersStore } from '../BasicParameters.store';
import { PARAMS_GRID_TITLES } from '../consts';
import type { ParameterLine } from '../ParameterLine.store';

import { ParameterRow } from './ParameterRow';

type Props = {
  store: BasicParametersStore;
  disabled: boolean;
};

export const ParametersGrid = observer(function ParametersGrid({ store, disabled }: Props) {
  const { t } = useTranslation();

  const paramsSorted = store.filteredAndSortedList.map<{ line: ParameterLine; title: string }>((param) => ({
    line: param,
    title: t(`settings:Parameters:${param.name}`, {
      mnemonic: param.defaultMnemonic ?? '',
    }),
  }));

  return (
    <div className={clsx(styles.parametersSelectionGrid, disabled && styles.parametersSelectionGrid__disabled)}>
      {PARAMS_GRID_TITLES.map((text) => (
        <div key={text} className={styles.parametersTitle}>
          {t(`settings:Headers:${text}`)}
        </div>
      ))}
      <div></div>
      <div></div>
      {paramsSorted.map(({ line, title }) => (
        <ParameterRow key={line.parameterType} line={line} title={title} store={store} />
      ))}
    </div>
  );
});
